import { IAjaxConfig } from '../helpers';
/**
 *  停机公告
 *  @swagger
 */
export class EnumApiOutagesNotice {
  /**
   * @dec
   * 根据展示位置类型查询公告信息
   */
  readonly outagesNotice_notice_get_by_position: IAjaxConfig = {
    url: '/api/gateway/outages-notice/v1/portal/public/notice/get',
    method: 'get',
    interceptErrMsg: true,
  };
  /**
   * @dec
   * 根据租户查询当前时间段内启用公告信息关联菜单id list
   */
  readonly outagesNotice_notice_get_by_menu: IAjaxConfig = {
    url: '/api/gateway/outages-notice/v1/portal/public/notice/menu/list',
    method: 'get',
    interceptErrMsg: true,
  };
  /**
   * @dec
   * 根据租户编码查询白名单
   */
  readonly outagesNotice_notice_white_by_tenantCode: IAjaxConfig = {
    url: '/api/gateway/outages-notice/v1/portal/notice/white/tenantCode/get',
    method: 'get',
    interceptErrMsg: true,
  };
}
